<template>
  <ResultForm :data="initData" @save="save"></ResultForm>
</template>
<script>
import LottoService from "@/services/lottoService"
import {lottoConfigs} from "@/configs/lotto.config.js"

import moment from "moment"
import ResultForm from "./ResultForm.vue"

export default {
  components: {
    ResultForm
  },
  data() {
    return {
      lotto: {
        lotto_id: null,
        lotto_type: this.$route.params.lottoType,
        lotto_date: moment().format("YYYY-MM-DD"),
        round: 'r2',
        show_result: moment().format("YYYY-MM-DD"),
        results: {
          prize_1st: '',
          prize_2nd: ''
        }
      }
    }
  },
  computed: {
    initData() {
      return this.lotto
    },
    lottoType() {
      return this.$route.params.lottoType
    }
  },
  watch: {
    lottoType() {

    }
  },
  methods: {
    save(data) {
      console.log('data', JSON.stringify(data))
      LottoService.saveResult({
        ...data,
        lotto_id: moment(data.lotto_date).format("YYYY-MM-DD")+'-'+data.round
      }).then((response) => {
        try {
          if (response.status === 'success') {
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'บันทึกผลหวยเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });

            this.$router.push({ name: 'admin-lotto-results', params: { lottoType: data.lotto_type } })
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'บันทึกผลหวยไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        } catch (e) {
          this.$vs.notify({
            title: 'ผิดพลาด(2)!',
            text: 'บันทึกผลหวยไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      })
    }
  },
  created() {

  }
}

</script>
